import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import ProductsView from "./ProductsView";
import CollectionBaseAdminView from "./CollectionBaseAdminView";
import CommerceUserView from "./CommerceUserView";
import StagesManager from "../../components/StagesManager";
import Cookies from "universal-cookie";
import { chooseFontColor, conditionalWidth } from "../../utils/useful";
import { CommercePages, FinanceAdminFrames } from "../../variables/AppletPages";


class FinanceApplet extends React.Component {
    state = {
        colors: {
            primaryColor: '#035352',
            secondaryColor: '#039A7B',
            textColor: '#fff'
        }
    }

    componentDidMount() {

        console.log("componentDidMount C")

        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }

        let frames = Object.values(FinanceAdminFrames.pages)
        let framesSections = Object.values(FinanceAdminFrames.sections)

        this.setState({ frames, framesSections })

    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {

            this.checkDefaultTab()
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(prevProps) {
        // let windowPath = this.props.windowData//.split('/')
        // windowPath = windowPath[windowPath.length - 1]

        // console.log('commeerceeeeee', prevProps, this.props.windowData, this.props.lastSelected);
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                // console.log('commeerceeeeee');
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }
    }



    checkDefaultTab() {


        // console.log("checkDefaultTab")
        let def = ''
        let pageType = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        rootRef = rootRef[rootRef.length - 1]

        let pageIsValid = false
        if (rootRef.includes('admin') || pathname.includes('admin')) {
            def = 'admin'
            pageType = 'admin'
            pageIsValid = true
        }
        // console.log(def)
        // console.log(rootRef)
        // console.log(pathname)


        if (!def) {
            def = ''
        }




        if (def === '') {
            pageType = ''
            pageIsValid = true

        }
        if (pageIsValid) {

            // console.log('page', pageType, def);
            this.setState({ oldData: this.props.windowData }, () => {


                this.setState({ path: def, pageType }, () => {
                    // console.log(pageType) 


                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            // console.log(pageInfo)
                            this.setState({ pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })

                // return
            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }

    setData = (key, value, reference, cb) => {
        if (reference == 'CommerceApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }


    render() {



        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        if (applet?.colorType == 'sameAsHub') {

        }

        if (applet?.colorType == "custom") {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`



        return (

            // <div className=" w-100 h-100 window-content-radius scroll-no-scrollbar " style={{ backgroundColor: '#F5F5F5' }}>
            <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>

                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >

                    <CollectionBaseAdminView setData={this.setData} stageName={'admin'} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} baseUrl={[...this.props.baseUrl, 'admin']} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} />
                    {/* <CommerceUserView setData={this.setData} stageName={''} baseUrl={this.props.baseUrl} language={this.props.language} colors={colors} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} /> */}

                </StagesManager>

            </div>
        )
    }
    //     return (

    //         <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>
    //             {this.props.adminView && (
    //                 <CollectionBaseAdminView stageName={'admin'} baseUrl={[...this.props.baseUrl, 'admin']} language={this.props.language} width={this.props.width} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} />
    //             )}

    //             {!this.props.adminView && (

    //                 <div className="h-100 w-100 scroll-no-scrollbar">
    //                     <CommerceUserView stageName={''} baseUrl={this.props.baseUrl} language={this.props.language} width={this.props.width} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} />
    //                 </div>
    //             )}
    //         </div>


    //     )
    // }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FinanceApplet);
